import React from "react"
import styled from "styled-components"
import Plan from "./Plan";
import breakpoints from "../../styles/breakpoints";

const PlansContainer = styled.div`
  @media(min-width: ${breakpoints.lg}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-items: stretch;
  }
`;

const PlanContainer = styled.div`
  width: 100%;

  @media(min-width: ${breakpoints.lg}) {
    width: 48%;    
  }
`;

const Plans = ({plans, subscription, selectPlan}) => {
  return (
    <PlansContainer>
      {plans && plans.map((plan, index) => {
        const {displayName, price, code} = plan;

        const isCurrent = plan.code === subscription.code;
        // Free is the default plan: it can't be purchased through Shopify
        // billing, so it's shown for comparison without a select button.
        const isSelectable = code !== "free";

        return (
          <PlanContainer key={index}>
            <Plan name={displayName}
                  price={`$${price} / month`}
                  code={code}
                  isCurrent={isCurrent}
                  isSelectable={isSelectable}
                  selectCopy={code === "pro" ? `Start 14-day free trial` : `Select plan`}
                  selectPlan={selectPlan}
                  first={index === 0}/>
          </PlanContainer>
        )
      })}
    </PlansContainer>
  );
};

export default Plans;
